import type { ConfigContactPayload } from '@bb/domain/dist/types';
import type {
  BaseConfigContact,
  ClientConfigContact,
} from '@bb/domain/dist/types/AppointmentConfig';
import axios from 'axios';
import { invalidateListingAppointmentConfigCache } from './getListingAppointmentConfig';

type CreateClientContactParams = {
  listingId: string;
};

type CreateClientContactBody = {
  contactBody: Omit<
    ConfigContactPayload<ClientConfigContact>,
    | 'canConfirmAppts'
    | 'canDenyAppts'
    | 'canSuggestTime'
    | 'importance'
    | 'notifications'
    | 'ownerId'
  >;
  contactConfig: Omit<ConfigContactPayload<BaseConfigContact>, 'type'>;
};

const createClientContact = async (
  params: CreateClientContactParams,
  body: CreateClientContactBody,
) => {
  const { data } = await axios.post(
    `/appointments/${params.listingId}/config/contacts/client`,
    body,
  );

  invalidateListingAppointmentConfigCache(params.listingId);

  return data;
};

export default createClientContact;
